import { useState, useMemo } from "react";
import {
  useExternalCategoriesControllerGetCategoryTree,
  CategoryTreeNodeDto,
} from "@semo/api-contracts";
import { flattenCategoryTree } from "@semo/shared-product";

export type CategoryMode = "all" | "dealing";

export type CategoryOption = CategoryTreeNodeDto & {
  pathName: string;
};

export const useCategoryTree = () => {
  const [mode, setMode] = useState<CategoryMode>("all");

  const {
    data: response,
    isLoading,
    error,
  } = useExternalCategoriesControllerGetCategoryTree({
    mode: mode,
  });

  const categoryTree = useMemo(() => {
    return response?.data || [];
  }, [response]);

  // Helper: Flatten tree for searching or list views if needed
  const flatCategories = useMemo(() => {
    const flattened = flattenCategoryTree(categoryTree);
    return flattened.map((item) => ({
      ...item.original,
      pathName: item.pathName,
    }));
  }, [categoryTree]);

  return {
    categoryTree,
    flatCategories,
    isLoading,
    error,
    mode,
    setMode,
  };
};
